import apiClient from './apiClient'

function accountParams(classifiedAccountId) {
	return { classifiedAccountId: String(classifiedAccountId) }
}

export function getAvitoHostedFeedErrorMessage(error) {
	const backendError = error?.response?.data?.error
	const messages = {
		HOSTED_FEED_NOT_FOUND: 'Ссылка для Авито ещё не подготовлена.',
		HOSTED_FEED_BUILD_FAILED:
			'Не удалось применить последние изменения. Автозагрузка продолжает работать с предыдущими данными.',
		HOSTED_FEED_ROTATION_CONFIRMATION_REQUIRED:
			'Подтвердите создание новой ссылки.',
		HOSTED_FEED_INPUT_INVALID: 'Проверьте выбранный аккаунт.',
		AUTOLOAD_OPERATION_FAILED:
			'Не удалось применить последние изменения. Предыдущие данные сохранены.',
	}
	return (
		messages[backendError?.code] ||
		(typeof backendError?.message === 'string'
			? backendError.message
			: 'Не удалось выполнить операцию с автозагрузкой.')
	)
}

export async function getAvitoHostedFeed(
	classifiedAccountId,
	client = apiClient
) {
	const response = await client.get(
		'/classifieds/avito/autoload/hosted-feed',
		{ params: accountParams(classifiedAccountId) }
	)
	return response.data
}

export async function createAvitoHostedFeed(
	classifiedAccountId,
	client = apiClient
) {
	const response = await client.post(
		'/classifieds/avito/autoload/hosted-feed',
		accountParams(classifiedAccountId)
	)
	return response.data
}

export async function rebuildAvitoHostedFeed(
	classifiedAccountId,
	client = apiClient
) {
	const response = await client.post(
		'/classifieds/avito/autoload/hosted-feed/rebuild',
		accountParams(classifiedAccountId)
	)
	return response.data
}

export async function getAvitoHostedFeedDiagnostics(
	classifiedAccountId,
	client = apiClient
) {
	const response = await client.get(
		'/classifieds/avito/autoload/hosted-feed/diagnostics',
		{ params: accountParams(classifiedAccountId) }
	)
	return response.data
}

export async function rotateAvitoHostedFeedToken(
	classifiedAccountId,
	client = apiClient
) {
	const response = await client.post(
		'/classifieds/avito/autoload/hosted-feed/rotate-token',
		{
			...accountParams(classifiedAccountId),
			confirm: true,
		}
	)
	return response.data
}
